/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Filtercount1Inputs */

const en_entity_filtercount1 = /** @type {(inputs: Entity_Filtercount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter Count`)
};

const de_entity_filtercount1 = /** @type {(inputs: Entity_Filtercount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filteranzahl`)
};

/**
* | output |
* | --- |
* | "Filter Count" |
*
* @param {Entity_Filtercount1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_filtercount1 = /** @type {((inputs?: Entity_Filtercount1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Filtercount1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_filtercount1(inputs)
	return de_entity_filtercount1(inputs)
});
export { entity_filtercount1 as "entity_filterCount" }